import React from "react";
import { strings } from '../localization/strings';

function Recap({ availability, excursion, date, adult, child, baby, nextStep, language, excursionName, tourUrl }) {
    const [showPriceDetail, setShowPriceDetail] = React.useState(false);
    const [totalPrice, setTotalPrice] = React.useState(0);
    const [adultPrice, setAdultPrice] = React.useState(0);
    const [childPrice, setChildPrice] = React.useState(0);
    const [adultTariff, setAdultTariff] = React.useState(0);
    const [childTariff, setChildTariff] = React.useState(0);
    const [entranceFeeAdultTariff, setEntranceFeeAdultTariff] = React.useState(0);
    const [entranceFee, setEntranceFee] = React.useState(0);
    const [totalPassengers, setTotalPassengers] = React.useState(0);
    const [adultChild, setAdultChild] = React.useState(0);
    const [tourImage, setTourImage] = React.useState('');

    const translation = strings[language] ?? strings.it;
    const tourDescription = language === 'it' ? excursion?.tourDescription : excursion?.tourDescriptionMulti[language];

    const clickNextStep = () => {
        nextStep();
    };

    React.useEffect(() => {
        let tourImage = excursion?.tourImage;
        if (tourImage && tourImage.startsWith('https') === false) {
            tourImage = excursion.baseUrl + tourImage;
        }
        setTourImage(tourImage);
    }, [excursion]);

    React.useEffect(() => {
        if (availability && availability.tariff) {
            setTotalPassengers(parseInt(adult) + parseInt(child) + parseInt(baby));
            const adultPriceCalc = availability.tariff.adult * adult;
            setAdultPrice(adultPriceCalc.toFixed(2).replace('.', ','));
            setAdultTariff(availability.tariff.adult.toFixed(2).replace('.', ','));
            const childPriceCalc = availability.tariff.reduced * child;
            setChildPrice(childPriceCalc.toFixed(2).replace('.', ','));
            setChildTariff(availability.tariff.reduced.toFixed(2).replace('.', ','));
            let total = adultPriceCalc + childPriceCalc;

            if (availability.entranceFee) {
                const entranceFeeCalc = availability.entranceFee.adult * adult + availability.entranceFee.reduced * child;
                setEntranceFeeAdultTariff(availability.entranceFee.adult.toFixed(2).replace('.', ','));
                setEntranceFee(entranceFeeCalc.toFixed(2).replace('.', ','));
                setAdultChild(parseInt(adult) + parseInt(child));
                total = total + entranceFeeCalc;
            }

            // show the total price with 2 decimal digits
            total = total.toFixed(2).replace('.', ',');
            setTotalPrice(total);
        }
    }, [availability, adult, child, baby]);

    function goBack() {
        if (tourUrl) {
            window.location.href = tourUrl;
        }
    }

    const tooltipStyleInt = {
        position: 'absolute',
        zIndex: '9999',
        background: '#000',
        padding: '10px',
        borderRadius: '3px',
        font: 'Jost, sans-serif',
        fontSize: '14px',
        color: '#fff',
        maxWidth: '200px'
    };

    const [showTooltip, setShowTooltip] = React.useState(false);
    const [tooltipStyle, setTooltipStyle] = React.useState({});

    const handleMouseEnter = () => {
        const tooltipElement = document.querySelector('.fa-square-pen');
        const header = document.querySelector('.tourmaster-payment-head');
        if (tooltipElement) {
            const rect = tooltipElement.getBoundingClientRect();
            const headerRect = header.getBoundingClientRect();
            tooltipStyleInt.left = `${rect.left - 40 + window.scrollX}px`;
            tooltipStyleInt.top = `${rect.top - headerRect.height -45 + window.scrollY}px`;
            
            setTooltipStyle(tooltipStyleInt);
        }
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    const [showTourDetails, setShowTourDetails] = React.useState(false);

    return (
        <div>
            <h5 className="recap-header">{translation.recapChoice}</h5>
            <div className="recap-separator" />
            <div className="recap-container" style={{cursor: 'pointer', 
                background: showTourDetails ? '#1f2d56' : undefined,
                color: showTourDetails ? 'white' : undefined,
                borderBottomLeftRadius: showTourDetails ? 0 : undefined,
                borderBottomRightRadius: showTourDetails ? 0 : undefined}} onClick={() => { setShowTourDetails(!showTourDetails)}}>
                <span className={"fa fa-icon fa-solid fa-xl " + (showTourDetails ? "fa-circle-minus" : "fa-circle-plus")}></span>
                <span style={{ marginLeft: '20px' }} />
                {excursionName}
            </div>
            {showTourDetails &&
                    <div className="recap-tour-details">
                        <img src={tourImage} alt={excursionName} className="recap-tour-image" />
                        <div className="recap-tour-message" dangerouslySetInnerHTML={{ __html: tourDescription }} />
                    </div>
            }
            <div className="recap-separator" />
            <div className="recap-container">
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    <div className="recap-column" style={{flex: 9}}>
                        <div className="recap-row">
                            <div className="recap-left-text">{translation.adults}:</div>
                            <div className="recap-next-sign recap-left-sign"><span></span></div>
                            <div className="recap-left-value">{adult}</div>
                            <div className="recap-left-tooltip"></div>
                        </div>
                        <div className="recap-row">
                            <div className="recap-left-text">{translation.children}:</div>
                            <div className="recap-next-sign recap-left-sign"><span></span></div>
                            <div className="recap-left-value">{child}</div>
                            <div className="recap-left-tooltip"></div>
                        </div>
                        { !excursion?.excludeFree &&
                            <div className="recap-row">
                                <div className="recap-left-text">{translation.infant}:</div>
                                <div className="recap-next-sign recap-left-sign"><span></span></div>
                                <div className="recap-left-value">{baby}</div>
                                <div className="recap-left-tooltip"></div>
                            </div>
                        }
                        <div className="recap-row" style={{height: '24px'}}></div>
                        <div className="recap-row">
                            <div className="recap-left-text">{translation.totPassengers}:</div>
                            <div className="recap-next-sign recap-left-sign"><span></span></div>
                            <div className="recap-left-value">{totalPassengers}</div>
                            <div className="recap-left-tooltip"></div>
                        </div>
                    </div>
                    <div className="recap-column" style={{flex: 10}}>
                        <div className="recap-row">
                            <div className="recap-right-text">{translation.date}:</div>
                            <div className="recap-next-sign recap-right-sign"><span></span></div>
                            <div className="recap-right-value">{date}</div>
                            <span className="fa fa-solid fa-square-pen recap-right-tooltip" style={{color: "#00a1a3", cursor: 'pointer'}} onClick={() => { goBack() }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}></span>
                            {showTooltip && <div style={{ ...tooltipStyle }}>{translation.modifyDate}</div>}
                        </div>
                        <div className="recap-row">
                            <div className="recap-right-text">{translation.departureTime}:</div>
                            <div className="recap-next-sign recap-right-sign"><span></span></div>
                            <div className="recap-right-value">{excursion?.departureTime}</div>
                            <div className="recap-right-tooltip"></div>
                        </div>
                        <div className="recap-row">
                            <div className="recap-right-text">{translation.price}:</div>
                            <div className="recap-next-sign recap-right-sign"><span></span></div>
                            <div className="recap-right-value">{totalPrice + ' €'}</div>
                            <div className="recap-right-tooltip"></div>
                        </div>
                        <div className="recap-row" style={{height: '24px'}}></div>
                        <div className="recap-price-detail-container" onClick={() => { setShowPriceDetail(!showPriceDetail) }}>
                            {translation.priceDetails}
                            <span className="fa fa-solid fa-caret-down" style={{float: 'right', color: '#fe3956', paddingTop: '5px' }}></span>
                        </div>
                        {showPriceDetail && <div className="recap-column recap-price-detail">
                            <div className="recap-row">
                                <div style={{flex: 2}}>{translation.adults}</div>
                                <div style={{flex: 1, textAlign: 'end'}}>{adultTariff}€</div>
                                <div style={{flex: 1, textAlign: 'end'}}>x {adult}</div>
                                <div style={{flex: 2, textAlign: 'end'}}>= {adultPrice}€</div>
                            </div>
                            <div className="recap-row">
                                <div style={{flex: 2}}>{translation.children}</div>
                                <div style={{flex: 1, textAlign: 'end'}}>{childTariff}€</div>
                                <div style={{flex: 1, textAlign: 'end'}}>x {child}</div>
                                <div style={{flex: 2, textAlign: 'end'}}>= {childPrice}€</div>
                            </div>
                            <div className="recap-row">
                                <div style={{flex: 2}}>{translation.AMPTax}</div>
                                <div style={{flex: 1, textAlign: 'end'}}>{entranceFeeAdultTariff}€</div>
                                <div style={{flex: 1, textAlign: 'end'}}>x {adultChild}</div>
                                <div style={{flex: 2, textAlign: 'end'}}>= {entranceFee}€</div>
                            </div>
                            <div className="recap-separator" style={{ height: '1px', background: '#ccc', margin: '10px 0' }}></div>
                            <div className="recap-row">
                                <div style={{flex: 2}}>{translation.totalShort}:</div>
                                <div style={{flex: 1}}></div>
                                <div style={{flex: 1}}></div>
                                <div style={{flex: 2, textAlign: 'end'}}> = {totalPrice}€</div>
                            </div>
                        </div>}
                        <a className="tourmaster-button" style={{borderRadius: '20px', marginTop: '20px', width: '100%', textAlign: 'center'}} onClick={clickNextStep}>
                        {translation.recapCallToAction} <span className="fa fa-solid fa-chevron-right" style={{marginLeft: '10px'}}></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Recap;